import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';
import Context from '../State/Context';

interface InterfaceProgressBar {
    className?: string,
    current: number,
    max: number,
}

const ProgressBarComponent = ({ className, current, max }: InterfaceProgressBar) => (
    <div className={className}>
        <div className="ActiveProgressBar">&nbsp;</div>
    </div>
);

const ProgressBar = styled(ProgressBarComponent)`
    background-color: ${Colours.panelBackground};

    .ActiveProgressBar {
        background-color: ${Colours.primary};
        height: 4px;
        width: ${({ current, max }) => Math.round(current/max*100) }%;
    }
`;

export default () => (
    <Context.Consumer>
        {({ page, maxPages }) => (
            <ProgressBar current={page} max={maxPages}/>
        )}
    </Context.Consumer>
);



// WEBPACK FOOTER //
// ./src/Components/ProgressBar.tsx